import React from "react";

interface Props {
  checked: boolean;
  onChange: (newState: boolean) => void;
  color?: string;
  className?: string;
}

const Checkbox: React.FC<Props> = ({ className, checked, onChange, children, color }) => {
  return (
    <div
      className={`flex items-center cursor-pointer select-none  ${className ? className : ""}`}
      style={{ color: color ? color : "" }}
      onClick={(e) => {
        e.preventDefault();
        onChange(!checked);
      }}
    >
      <input
        className="hidden"
        type={"checkbox"}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      {checked && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="2xl:w-6 w-3"
          // width="12"
          // height="12"
          viewBox="0 0 12 12"
        >
          <path
            fill="currentColor"
            d="M16.667-681H7.333A1.333 1.333 0 006-679.667v9.333A1.333 1.333 0 007.333-669h9.333A1.333 1.333 0 0018-670.333v-9.333A1.333 1.333 0 0016.667-681zm-6 9.333L7.333-675l.94-.94 2.393 2.387 5.06-5.06.94.947z"
            data-name="Selection Control / Checkbox / On / Enabled"
            transform="translate(-6 681)"
          ></path>
        </svg>
      )}
      {!checked && (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
          <g data-name="Group 2375" transform="translate(-1 -1)">
            <path
              fill="currentColor"
              d="M16.667-681H7.333A1.333 1.333 0 006-679.667v9.333A1.333 1.333 0 007.333-669h9.333A1.333 1.333 0 0018-670.333v-9.333A1.333 1.333 0 0016.667-681z"
              data-name="Selection Control / Checkbox / On / Enabled"
              transform="translate(-5 682)"
            ></path>
            <path
              fill="#fff"
              d="M14.889-681H7.111A1.111 1.111 0 006-679.889v7.778A1.111 1.111 0 007.111-671h7.778A1.111 1.111 0 0016-672.111v-7.778A1.111 1.111 0 0014.889-681z"
              data-name="Selection Control / Checkbox / On / Enabled"
              transform="translate(-4 683)"
            ></path>
          </g>
        </svg>
      )}
      {children}
    </div>
  );
};

export default Checkbox;
